// extracted by mini-css-extract-plugin
export default {"modernBtn":"modern-btn_modernBtn__EiSWM"};